import { RepositoryFactory } from "./../repository/RepositoryFactory";
import Util from "./../lib/util.js";
import Logger from "./../lib/logger";
import { makeCancellable, takeLatest } from "vuex-cancellable-actions";

const ConfigRepository = RepositoryFactory.get("config");
const systemDataRepository = RepositoryFactory.get("systemData");
export default {
  namespaced: true,
  state: {
    /** 設定情報 */
    config: undefined,
    /** 表示モード [pc:PCモード, mb:モバイルモード] */
    mode: "pc",
    /** 観測日時 [true:最新, false:履歴] */
    isCurrent: true,
    /** 観測日時 */
    appTime: Util.toDate(),
    /** TM観測日時(ファイル取得用) */
    appTimeRound: null,
    /** 河川予警報観測日時(ファイル取得用) */
    appTimeRoundRw: null,
    /** TM最新観測日時 */
    crntTime: null,
    /** 河川予警報最新観測日時 */
    crntRwTime: null,
    /** パネル拡大モード */
    pcPanelMode: false,
    /** パネル拡大モード時の表示コンテンツ */
    pcPanelModeContent: "",
    // 表示コンテンツ
    content: "",
    // FireBaseトークン
    token: "",
    // 通知許可 true:許可
    permission: "",
    // 水防団モード
    fldCtlParty: "0",
    // referrer
    referrer: "",
    // 通知許可説明表示
    showNotification: false,
    // 水位表示 [0:河床からの水位 1:堤防天端からの水位]
    stgMode: "0",
    /** 画面遷移時の保持日時 */
    retentionTime: new Date(),
    /** 画面遷移時の保持日時状態 [true:最新, false:履歴] */
    retentionCurrent: true,
  },
  getters: {
    /** 水防団モード(boolean)を返す */
    isFldCtl: (state) => {
      if (state.fldCtlParty === "1") {
        return true;
      }
      return false;
    },
  },
  mutations: {
    /** 設定情報を設定 */
    setConfig(state, config) {
      Logger.debug("[app]mut - setConfig()");
      Logger.dir(config);
      state.config = config;
    },
    /** 表示モード設定 */
    setMode(state, val) {
      Logger.debug("[app]mut - setMode(" + val + ")");
      state.mode = val;
    },
    /** 観測日時更新 */
    renewTime(state) {
      Logger.debug("[app]mut - renewTime()");
      state.appTime = Util.toDate();
      state.isCurrent = true;
    },
    /** 観測日時設定 */
    setTime(state, date) {
      Logger.debug("[app]mut - setTime(" + date + ")");
      state.appTime = date;
      state.isCurrent = false;
    },
    /** TM観測日時(ファイル取得用)設定 */
    setAppTimeRound(state, date) {
      Logger.debug("[app]mut - setAppTimeRound(" + date + ")");
      state.appTimeRound = date;
    },
    /** 河川予警報観測日時(ファイル取得用)設定 */
    setAppTimeRoundRw(state, date) {
      Logger.debug("[app]mut - setAppTimeRoundRw(" + date + ")");
      state.appTimeRoundRw = date;
    },
    /** TM最新観測日時設定 */
    setCrntTime(state, date) {
      Logger.debug("[app]mut - setCrntTime(" + date + ")");
      state.crntTime = date;
    },
    /** 河川予警報最新観測日時設定 */
    setCrntRwTime(state, date) {
      Logger.debug("[app]mut - setCrntRwTime(" + date + ")");
      state.crntRwTime = date;
    },
    /** PCパネル拡大表示モード */
    setPcPanelMode(state, val) {
      Logger.debug("[app]mut - setPcPanelMode(" + val + ")");
      state.pcPanelMode = val;
    },
    /** パネル拡大モード時の表示コンテンツ */
    setPcPanelModeContent(state, val) {
      Logger.debug("[app]mut - setPcPanelModeContent(" + val + ")");
      state.pcPanelModeContent = val;
    },
    /** 表示コンテンツ */
    setContent(state, content) {
      Logger.debug("[app]mut - setContent(" + content + ")");
      state.content = content;
    },
    /** プッシュ通知用のトークン */
    setToken(state, token) {
      Logger.debug("[app]mut - setToken:" + token);
      state.token = token;
    },
    //
    /** 通知許可 */
    setPermission(state, permission) {
      Logger.debug("[app]mut - setPermission:" + permission);
      state.permission = permission;
    },
    /** 水防団モード */
    setFldCtlParty(state, val) {
      Logger.debug("[app]mut - setFldCtlParty(" + val + ")");
      // 0 または 1 の場合のみ更新する
      if (val === "0" || val === "1") {
        state.fldCtlParty = val;
      }
    },
    /** referrer */
    setReferrer(state, referrer) {
      Logger.debug("[app]mut - setReferrer(" + referrer + ")");
      state.referrer = referrer;
    },
    /** 通知許可説明表示設定 */
    setShowNotification(state, showFlg) {
      Logger.debug("[app]mut - setShowNotification(" + showFlg + ")");
      state.showNotification = showFlg;
    },
    /** 水位表示設定 */
    setStgMode(state, val) {
      Logger.debug("[app]mut - setStgMode(" + val + ")");
      state.stgMode = val;
    },
    /** 画面遷移時の保持日時設定 */
    setRetentionTime(state, current) {
      Logger.debug(
        "[radar]mut - setRetentionTime(" +
          current.time +
          ", " +
          current.flag +
          ")"
      );
      state.retentionTime = current.time;
      state.retentionCurrent = current.flag;
    },
  },
  actions: makeCancellable({
    async initConfig({ commit }) {
      Logger.debug("[app]act - initConfig()");
      // APIからデータ取得
      const { data } = await ConfigRepository.getSetting();

      Logger.dir(data);

      // 取得情報をストアに格納
      commit("setConfig", data);
    },
    /** 最新観測時刻ファイルを取得し、観測日時(ファイル取得用)を更新 */
    getCrntTime: takeLatest(async function({ state, commit }) {
      Logger.debug("[app]act - getCrntTime()");

      // APIからデータ取得
      // TM最新観測時刻
      Logger.debug("[app]API - getLatestTmObsTime()");
      const {
        data: tmData,
        error: tmError,
      } = await systemDataRepository.getLatestTmObsTime();
      Logger.debug("[app]API - getLatestTmObsTime() - return");
      Logger.dir(tmData);
      Logger.dir(tmError);
      if (!tmError) {
        commit("setCrntTime", Util.toDate(tmData.crntObsTime));
      }
      commit(
        "setAppTimeRound",
        Util.roundMinutes(
          state.appTime,
          state.config.appConfig.keepDaysJsonFiles,
          state.crntTime
        )
      );

      // 河川予警報最新時刻
      Logger.debug("[app]API - getLatestRwTime()");
      const {
        data: rwData,
        error: rwError,
      } = await systemDataRepository.getLatestRwTime();
      Logger.debug("[app]API - getLatestRwTime() - return");
      Logger.dir(rwData);
      Logger.dir(rwError);
      if (!rwError) {
        commit("setCrntRwTime", Util.toDate(rwData.crntRwTime));
      }
      commit(
        "setAppTimeRoundRw",
        Util.roundMinutes(
          state.appTime,
          state.config.appConfig.keepDaysJsonFiles,
          state.crntRwTime
        )
      );
    }),
  }),
};
